import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";
import profileImage from "../../../../images/user/Default_pfp.png";
import { rebInvCreateDateConvert, rebInvDueDateConvert } from "./Services/reportReimbursement";
import PaymentStatus from "../../../Invoices/elements/paymentStatusWise";

// Dummy data for testing
const dummyData = [
  {
    user: {
      name: "Rey Bugawan",
      profilePhoto: profileImage,
    },
    category: "Travel",
    creationDate: "2023-07-01",
    dueDate: "2023-07-10",
    paymentStatus: "Paid",
    amount: 1500,
  },
  {
    user: {
      name: "Calin Tatar",
      profilePhoto: profileImage,
    },
    category: "Medical",
    creationDate: "2023-07-01",
    dueDate: "2023-07-10",
    paymentStatus: "Pending",
    amount: 200,
  },
  {
    user: {
      name: "Jane Smith",
      profilePhoto: profileImage,
    },
    category: "Office Supplies",
    creationDate: "2023-07-02",
    dueDate: "2023-07-15",
    paymentStatus: "Overdue",
    amount: 75,
  },
  // Add more dummy data as needed
];

const ReimburesmentTable = ({ reimbursementInv, reimbursementInvLoading, reimbursementInvError }) => {
  const reportingReimbursment = useSelector((state) => state.reportingReimbursment);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (reimbursementInv && reportingReimbursment) {
      const timeZone = global.config.getTimeZone();
      const firstDayOfYear = moment.tz(timeZone).startOf("year").toDate();
      const dateRange = reportingReimbursment.reimbursmentDateRange || [firstDayOfYear, new Date()];
      const startDate = moment.tz(dateRange[0], timeZone);
      const endDate = moment.tz(dateRange[1], timeZone);
      const filtered = reimbursementInv.filter((invoice) => {
        const invoiceIssueDate = moment.tz(invoice?.inv_issue_date, timeZone);
        return (
          invoice &&
          !invoice.is_delete &&
          (reportingReimbursment.reimbursmentUser && reportingReimbursment.reimbursmentUser.includes(invoice.inv_for._id)) &&
          (reportingReimbursment.reimbursmentInvStatus && reportingReimbursment.reimbursmentInvStatus.includes(invoice?.inv_status || 0)) &&
          (reportingReimbursment.reimbursmentInvPaymentStatus && reportingReimbursment.reimbursmentInvPaymentStatus.includes(invoice?.inv_payment_status || 0)) &&
          invoiceIssueDate.isBetween(startDate, endDate, null, '[]')
        );
      });

      const sortedData = filtered.sort((a, b) => new Date(b.inv_created_at) - new Date(a.inv_created_at));
      setFilteredData(sortedData);
    }
  }, [reimbursementInv, reportingReimbursment]);

  const useRenderMemberName = (rowData) => {
    const [showFullname, setShowFullname] = useState(false);

    const fullName =
      (rowData.inv_for.first_name || rowData.inv_for.company_name) +
      (rowData.inv_for.middle_name && rowData.inv_for.middle_name !== "null"
        ? " " + rowData.inv_for.middle_name
        : "") +
      " " +
      rowData.inv_for.last_name;
    const displayName = showFullname
      ? fullName
      : fullName.length <= 15
        ? fullName
        : fullName.slice(0, 15) + "...";

    return (
      <div
        className={`member-name${showFullname ? " active" : ""}`}
        // onMouseEnter={() => setShowFullname(true)}
        onMouseEnter={() => {
          if (fullName.length > 15) {
            setShowFullname(true);
          }
        }}
        onMouseLeave={() => setShowFullname(false)}
      >
        {rowData.inv_for.profile_image !== null &&
          rowData.inv_for.profile_image !== "null" ? (
          <img
            src={`/uploads/lowProfileImage/${rowData.inv_for.profile_image}`}
            alt={fullName}
            className="member-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/uploads/lowProfileImage/user_default.png";
            }}
          />
        ) : (
          <img src={profileImage} alt={fullName} className="member-image" />
        )}
        <span>{displayName}</span>
      </div>
    );
  };

  const renderAmount = (rowData) => {
    var totalAmount = rowData.inv_total_amount.toLocaleString("en-US", {
      style: "currency",
      currency: rowData.inv_currency,
    });

    return <span> {totalAmount}</span>;
  };

  if (reimbursementInvLoading) {
    return (
      <div className="datatable-team-maintb">
        <div className="p-datatable p-component p-datatable-responsive-scroll" style={{ marginBottom: 0, paddingBottom: 0 }}>
          <div className="p-datatable-wrapper" style={{ paddingBottom: 0, marginBottom: 0 }}>
            <table
              className="p-datatable-table"
              style={{ minWidth: "50rem", width: "100%", textAlign: "left", marginBottom: 0, borderSpacing: 0 }}
            >
              <thead className="p-datatable-thead">
                <tr>
                  <th style={{ width: "20%", paddingRight: "20px", textAlign: "left", paddingLeft: "22px", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>User</th>
                  <th style={{ width: "15%", paddingRight: "20px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Category</th>
                  <th style={{ paddingRight: "44px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Creation Date</th>
                  <th style={{ paddingRight: "44px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Due Date</th>
                  <th style={{ paddingRight: "44px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Payment Status</th>
                  <th style={{ paddingRight: "44px", textAlign: "left", paddingTop: "11px", paddingBottom: "12px", background: "#F5F6F8", fontWeight: 500, fontSize: "17px", lineHeight: "21px", color: "#6A7988" }}>Amount</th>
                </tr>
              </thead>
              <tbody className="p-datatable-tbody" style={{ marginBottom: 0, paddingBottom: 0 }}>
                {Array.from({ length: 5 }).map((_, index) => (
                  <tr key={`skeleton-${index}`}>
                    <td style={{ width: "20%", paddingRight: "20px", paddingLeft: "22px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: "#e5e7eb", animation: "pulse 1.5s ease-in-out infinite", flexShrink: 0 }} />
                        <div style={{ width: "120px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                      </div>
                    </td>
                    <td style={{ width: "15%", paddingRight: "20px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                    </td>
                    <td style={{ paddingRight: "44px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ width: "100px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                    </td>
                    <td style={{ paddingRight: "44px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ width: "100px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                    </td>
                    <td style={{ paddingRight: "44px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ width: "90px", height: "24px", backgroundColor: "#e5e7eb", borderRadius: "12px", animation: "pulse 1.5s ease-in-out infinite" }} />
                    </td>
                    <td style={{ paddingRight: "44px", paddingTop: "12px", paddingBottom: "12px", borderBottom: "1px solid #E5E7EB" }}>
                      <div style={{ width: "80px", height: "20px", backgroundColor: "#e5e7eb", borderRadius: "4px", animation: "pulse 1.5s ease-in-out infinite" }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <style>{`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div className="datatable-team-maintb">
      <DataTable
        value={filteredData.slice(0, 5)}
        emptyMessage={
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
              <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
              <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
              <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No reimbursements found</p>
            <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters.</p>
          </div>
        }
        tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
      >
        <Column
          field="inv_for.first_name"
          body={useRenderMemberName}
          header="User"
          sortable
          style={{ width: "20%", paddingRight: "20px" }}
          sortField="fullName"
          sortFunction={(e) => {
            const dataCopy = [...filteredData];
            dataCopy.sort((rowData1, rowData2) => {
              const fullName1 =
                (rowData1.inv_for.first_name ||
                  rowData1.inv_for.company_name) +
                (rowData1.inv_for.middle_name &&
                  rowData1.inv_for.middle_name !== "null"
                  ? " " + rowData1.inv_for.middle_name
                  : "") +
                " " +
                rowData1.inv_for.last_name;

              const fullName2 =
                (rowData2.inv_for.first_name ||
                  rowData2.inv_for.company_name) +
                (rowData2.inv_for.middle_name &&
                  rowData2.inv_for.middle_name !== "null"
                  ? " " + rowData2.inv_for.middle_name
                  : "") +
                " " +
                rowData2.inv_for.last_name;

              // Implement your custom comparison logic here
              return e.order === 1
                ? fullName1.localeCompare(fullName2)
                : fullName2.localeCompare(fullName1);
            });
            return dataCopy;
          }}
        ></Column>
        <Column
          field="inv_category"
          header="Category"
          sortable
          style={{ width: "15%", paddingRight: "20px" }}
        />
        <Column
          field="inv_created_at"
          body={rebInvCreateDateConvert}
          header="Creation Date"
          sortable
          style={{ paddingRight: "44px" }}
        ></Column>
        <Column
          field="inv_due_date"
          body={rebInvDueDateConvert}
          header="Due Date"
          className="fixed-sec3"
          sortable
          style={{ paddingRight: "44px" }}
        ></Column>
        <Column
          field="inv_payment_status"
          header="Payment Status"
          body={(rowData) => (
            <PaymentStatus
              inv_payment_details={rowData.inv_payment_details}
              invData={rowData}
            />
          )}
          sortable
          style={{ paddingRight: "44px" }}
        ></Column>
        <Column
          field="inv_total_amount"
          header="Amount"
          body={renderAmount}
          className="amount-bold"
          sortable
          style={{ paddingRight: "44px" }}
        ></Column>
      </DataTable>
    </div>
  );
};

export default ReimburesmentTable;
